import React from "react";
import { RCCGrid } from "react-common-components";
import SortableItem from "src/components/Sortable/Item";
import { v4 } from "uuid";
import SortableContainerWithoutContext from "src/components/Sortable/ContainerWithoutContext";
import { verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import Objective from "./objective";
import { IMetba003, IObjectives } from "./interface";

const ObjectivesList: React.FC<IObjectives> = ({
	perspective,
	objectives
}) => (
	<>
		<SortableContainerWithoutContext
			items={objectives}
			strategy={verticalListSortingStrategy}
		>
			<RCCGrid container item styleInline="min-height: 100px; padding: 10px 0;">
				{
					objectives && objectives.map((objective:IMetba003) => (
						<RCCGrid 
							container 
							item
							xs={12}
							sm={6} 
							md={4}
							lg={3}
							key={v4()}
						>
							<SortableItem id={`o-${objective.id}`} >
								<RCCGrid>
									<Objective
										objective={objective}
										perspective={perspective}
									/>
								</RCCGrid>
							</SortableItem>
						</RCCGrid>
					))       
				}
			</RCCGrid>
		</SortableContainerWithoutContext>
	</>
);

export default ObjectivesList;

